import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'menu-button-specs',
  templateUrl: './menu-button-specs.component.html',
  styleUrls: ['./menu-button-specs.component.sass']
})
export class MenuButtonSpecsComponent implements OnInit {
  public component = window.location.protocol + '//' + window.location.host + '/design-specs-measure/menu-button/';
  constructor() { }

  ngOnInit(): void {
  }

  clickEvent(route) {
    if(route == 'light') {
      window.open(this.component, "_blank");
    }
  }

}
